// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "user/v1/user.proto" (package "user.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private user RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InternalUserService } from "./user";
import type { DeclineOrganizationInviteResponse } from "./user";
import type { DeclineOrganizationInviteRequest } from "./user";
import type { AcceptOrganizationInviteResponse } from "./user";
import type { AcceptOrganizationInviteRequest } from "./user";
import type { GetUserInvitesResponse } from "./user";
import type { GetUserInvitesRequest } from "./user";
import type { AddRoleWithoutApprovalResponse } from "./user";
import type { AddRoleWithoutApprovalRequest } from "./user";
import type { ListAllOrganizationsResponse } from "./user";
import type { ListAllOrganizationsRequest } from "./user";
import type { SetUserOrgLastAccessResponse } from "./user";
import type { SetUserOrgLastAccessRequest } from "./user";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAppUserResponse } from "./user";
import type { GetAppUserRequest } from "./user";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service user.v1.InternalUserService
 */
export interface IInternalUserServiceClient {
    /**
     * Gets user details of requester
     *
     * @generated from protobuf rpc: GetAppUser(user.v1.GetAppUserRequest) returns (user.v1.GetAppUserResponse);
     */
    getAppUser(input: GetAppUserRequest, options?: RpcOptions): UnaryCall<GetAppUserRequest, GetAppUserResponse>;
    /**
     * Update that last_access time of an org for a user
     *
     * @generated from protobuf rpc: SetUserOrgLastAccess(user.v1.SetUserOrgLastAccessRequest) returns (user.v1.SetUserOrgLastAccessResponse);
     */
    setUserOrgLastAccess(input: SetUserOrgLastAccessRequest, options?: RpcOptions): UnaryCall<SetUserOrgLastAccessRequest, SetUserOrgLastAccessResponse>;
    /**
     * Lists organizations across the platform, optionally filtered by a search
     * term. Restricted to Viam employees; used by the internal org admin page.
     *
     * @generated from protobuf rpc: ListAllOrganizations(user.v1.ListAllOrganizationsRequest) returns (user.v1.ListAllOrganizationsResponse);
     */
    listAllOrganizations(input: ListAllOrganizationsRequest, options?: RpcOptions): UnaryCall<ListAllOrganizationsRequest, ListAllOrganizationsResponse>;
    /**
     * Grants the requesting user the owner role on an organization, bypassing the
     * normal invite/approval flow. Restricted to Viam employees.
     *
     * @generated from protobuf rpc: AddRoleWithoutApproval(user.v1.AddRoleWithoutApprovalRequest) returns (user.v1.AddRoleWithoutApprovalResponse);
     */
    addRoleWithoutApproval(input: AddRoleWithoutApprovalRequest, options?: RpcOptions): UnaryCall<AddRoleWithoutApprovalRequest, AddRoleWithoutApprovalResponse>;
    /**
     * List all pending org invites for the current user
     *
     * @generated from protobuf rpc: GetUserInvites(user.v1.GetUserInvitesRequest) returns (user.v1.GetUserInvitesResponse);
     */
    getUserInvites(input: GetUserInvitesRequest, options?: RpcOptions): UnaryCall<GetUserInvitesRequest, GetUserInvitesResponse>;
    /**
     * Accept a pending org invite, adding the current user to the organization
     *
     * @generated from protobuf rpc: AcceptOrganizationInvite(user.v1.AcceptOrganizationInviteRequest) returns (user.v1.AcceptOrganizationInviteResponse);
     */
    acceptOrganizationInvite(input: AcceptOrganizationInviteRequest, options?: RpcOptions): UnaryCall<AcceptOrganizationInviteRequest, AcceptOrganizationInviteResponse>;
    /**
     * Decline a pending org invite, removing it without joining the organization
     *
     * @generated from protobuf rpc: DeclineOrganizationInvite(user.v1.DeclineOrganizationInviteRequest) returns (user.v1.DeclineOrganizationInviteResponse);
     */
    declineOrganizationInvite(input: DeclineOrganizationInviteRequest, options?: RpcOptions): UnaryCall<DeclineOrganizationInviteRequest, DeclineOrganizationInviteResponse>;
}
/**
 * @generated from protobuf service user.v1.InternalUserService
 */
export class InternalUserServiceClient implements IInternalUserServiceClient, ServiceInfo {
    typeName = InternalUserService.typeName;
    methods = InternalUserService.methods;
    options = InternalUserService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Gets user details of requester
     *
     * @generated from protobuf rpc: GetAppUser(user.v1.GetAppUserRequest) returns (user.v1.GetAppUserResponse);
     */
    getAppUser(input: GetAppUserRequest, options?: RpcOptions): UnaryCall<GetAppUserRequest, GetAppUserResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppUserRequest, GetAppUserResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update that last_access time of an org for a user
     *
     * @generated from protobuf rpc: SetUserOrgLastAccess(user.v1.SetUserOrgLastAccessRequest) returns (user.v1.SetUserOrgLastAccessResponse);
     */
    setUserOrgLastAccess(input: SetUserOrgLastAccessRequest, options?: RpcOptions): UnaryCall<SetUserOrgLastAccessRequest, SetUserOrgLastAccessResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetUserOrgLastAccessRequest, SetUserOrgLastAccessResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Lists organizations across the platform, optionally filtered by a search
     * term. Restricted to Viam employees; used by the internal org admin page.
     *
     * @generated from protobuf rpc: ListAllOrganizations(user.v1.ListAllOrganizationsRequest) returns (user.v1.ListAllOrganizationsResponse);
     */
    listAllOrganizations(input: ListAllOrganizationsRequest, options?: RpcOptions): UnaryCall<ListAllOrganizationsRequest, ListAllOrganizationsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAllOrganizationsRequest, ListAllOrganizationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Grants the requesting user the owner role on an organization, bypassing the
     * normal invite/approval flow. Restricted to Viam employees.
     *
     * @generated from protobuf rpc: AddRoleWithoutApproval(user.v1.AddRoleWithoutApprovalRequest) returns (user.v1.AddRoleWithoutApprovalResponse);
     */
    addRoleWithoutApproval(input: AddRoleWithoutApprovalRequest, options?: RpcOptions): UnaryCall<AddRoleWithoutApprovalRequest, AddRoleWithoutApprovalResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddRoleWithoutApprovalRequest, AddRoleWithoutApprovalResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List all pending org invites for the current user
     *
     * @generated from protobuf rpc: GetUserInvites(user.v1.GetUserInvitesRequest) returns (user.v1.GetUserInvitesResponse);
     */
    getUserInvites(input: GetUserInvitesRequest, options?: RpcOptions): UnaryCall<GetUserInvitesRequest, GetUserInvitesResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetUserInvitesRequest, GetUserInvitesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Accept a pending org invite, adding the current user to the organization
     *
     * @generated from protobuf rpc: AcceptOrganizationInvite(user.v1.AcceptOrganizationInviteRequest) returns (user.v1.AcceptOrganizationInviteResponse);
     */
    acceptOrganizationInvite(input: AcceptOrganizationInviteRequest, options?: RpcOptions): UnaryCall<AcceptOrganizationInviteRequest, AcceptOrganizationInviteResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<AcceptOrganizationInviteRequest, AcceptOrganizationInviteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Decline a pending org invite, removing it without joining the organization
     *
     * @generated from protobuf rpc: DeclineOrganizationInvite(user.v1.DeclineOrganizationInviteRequest) returns (user.v1.DeclineOrganizationInviteResponse);
     */
    declineOrganizationInvite(input: DeclineOrganizationInviteRequest, options?: RpcOptions): UnaryCall<DeclineOrganizationInviteRequest, DeclineOrganizationInviteResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeclineOrganizationInviteRequest, DeclineOrganizationInviteResponse>("unary", this._transport, method, opt, input);
    }
}
